import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IClub } from '../../models/club.model';
import { CoreService } from '../../services/core.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js';
import { StripeConfigService } from '../../../stripe-config.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-qr-popup',
  templateUrl: './qr-popup.component.html',
  styleUrls: ['./qr-popup.component.css'],
})
export class QRPopupComponent {
  selectedPayment: any = null;
  paid = false;
  isCard = false;
  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  cardElement: StripeCardElement | null = null;
  clientSecret: string = '';
  isLoading: boolean = false;
  paymentStatus: string = '';
  isCardComplete: boolean = false;
  selectedPaymentIndex = 0;
  existingClub: IClub = <IClub>{};
  leagueId: number = 0;

  constructor(private fb: FormBuilder,
    private http: HttpClient,
    private stripeConfig: StripeConfigService, public dialogRef: MatDialogRef<QRPopupComponent>, @Inject(MAT_DIALOG_DATA) private data: { club: IClub, leagueId: number }, private coreService: CoreService) {
    this.existingClub = data.club;
    this.leagueId = data.leagueId;
    this.onPaymentTabChange(0);
  }

  async callCard() {
    // Initialize Stripe
    const publishableKey = await this.stripeConfig.getStripePublicKey();
    this.stripe = await loadStripe(publishableKey);

    if (this.stripe) {
      this.elements = this.stripe.elements();
      const isVerySmall = window.innerWidth <= 336;
      // Create card element
      this.cardElement = this.elements.create('card', {
        style: {
          base: {
            fontSize: isVerySmall ? '10px' : '16px',
      lineHeight: isVerySmall ? '30px' : '24px',
            color: '#424770',
            '::placeholder': {
              color: '#aab7c4',
            },
          },
        },
      });

      // Add event listener to track card completion
      this.cardElement.on('change', (event) => {
        this.isCardComplete = event.complete;
      });

      // Mount card element after view init
      setTimeout(() => {
        this.cardElement?.mount('#card-element');
      }, 100);
    }
  }

  onPaymentTabChange(index: number) {
    this.selectedPaymentIndex = index;
    this.paid = false;
    this.elements = null;
    this.cardElement = null;
    this.clientSecret = '';
    this.isLoading = false;
    this.paymentStatus = '';
    this.isCardComplete = false;
    if (this.existingClub?.payments?.[index]) {
      this.selectedPayment = this.existingClub.payments[index];
      this.isCard = this.selectedPayment?.paymentOption?.toLocaleLowerCase()?.startsWith('card') || false;
    }
    if (this.isCard) {
      setTimeout(() => {
        this.callCard();
      }, 1000);
    }
  }

  async onSubmit() {
    if (this.isCard) {
      console.log(this.cardElement);
      if (!this.existingClub.fees || !this.stripe || !this.cardElement) {
        return;
      }
      this.isLoading = true;
      this.paymentStatus = '';
      const amount = this.existingClub.fees.toString();
      try {
        // Create payment intent
        const response = await this.coreService.postApi(`/api/Payment/CreatePaymentIntent`, {
          amount: parseFloat(amount),
          leagueId: this.leagueId,
        }).toPromise();

        if (response?.clientSecret) {
          // Confirm payment
          const { error } = await this.stripe.confirmCardPayment(response.clientSecret, {
            payment_method: {
              card: this.cardElement,
            }
          });
          if (error) {
            this.paymentStatus = `Payment failed: ${error.message}`;
          } else {
            this.paymentStatus = 'Payment successful! Thank you for your payment.';
            this.dialogRef.close(true);
          }
        }
      } catch (error: any) {
        this.paymentStatus = `Error: ${error.message}`;
      }
      this.isLoading = false;
    } else {
      // Direct payment intent
    }
  }

  updatePaid(e: MatCheckboxChange) {
    this.paid = e.checked
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
